import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import '@/assets/css/font.css'
import './style/fonts.scss'
import './style/globol.scss'
import vuetify from './plugins/vuetify'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// register globally
Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,

  render: h => h(App),
}).$mount('#app')
